const VISIBLE_CLASS = "--visible";
const SHOW_OFFSET = 320;

const shouldReduceMotion = (): boolean =>
  window.matchMedia("(prefers-reduced-motion: reduce)").matches;

export const initGoToTop = (): void => {
  if (typeof document === "undefined" || typeof window === "undefined") return;

  const button = document.getElementById("gototop-btn") as HTMLButtonElement | null;

  if (!button || button.dataset.goToTopInitialized === "true") return;

  button.dataset.goToTopInitialized = "true";

  const setVisible = (isVisible: boolean): void => {
    button.classList.toggle(VISIBLE_CLASS, isVisible);
    button.setAttribute("aria-hidden", String(!isVisible));
    button.tabIndex = isVisible ? 0 : -1;
  };

  const updateVisibility = (): void => {
    setVisible(window.scrollY > SHOW_OFFSET);
  };

  let isTicking = false;

  const requestVisibilityUpdate = (): void => {
    if (isTicking) return;

    isTicking = true;
    window.requestAnimationFrame(() => {
      updateVisibility();
      isTicking = false;
    });
  };

  button.addEventListener("click", () => {
    window.scrollTo({
      top: 0,
      behavior: shouldReduceMotion() ? "auto" : "smooth",
    });
  });

  window.addEventListener("scroll", requestVisibilityUpdate, { passive: true });
  updateVisibility();
};
